'use strict';

/*
DOCUMENT ME
*/
define('modules/module-canvas',[
  'require',
  'jquery',
  'Handlebars',
  './module-registry',
  'responsive',
  'lib/util/tda.config',
  'lib/tda/all',
  'bat'
], function (
  require,
  $,
  Handlebars,
  ModuleRegistry,
  responsive,
  tdaConfig,
  tdaAll,
  bat
) {
  // Default layout json (if none provided via bat-modules.xsl component within TeamSite)
  // overwrite, for local purposes
  var layout = {};

  // This is a helper to support url mangling for the different environments.
  var __resourceLocator = function (url) {
    if (url.startsWith('/web_docs/img/')) {
      url = tdaAll.localImgPath(url);
    }
    if (url.startsWith('/img/')) {
      url = '/' + tdaConfig.tda.code + url;
    }
    return url;
  };

  Handlebars.registerHelper('module-src', function (url) {
    if (!url || url.indexOf('http') === 0 || url.indexOf('//') === 0) {
      return url;
    }
    return __resourceLocator(url);
  });

  var __callback = function (self, opt, e) {
    if (opt[e] && typeof opt[e] == 'function') {
      opt[e].apply(self, Array.prototype.slice.call(arguments, 3));
    }
  };

  var ModuleCanvas = function (opt) {
    if (!opt.el) {
      console.error('ModuleCanvas: el option is required!');
      return;
    }

    // Hmmm.... store some settings
    this.options = $.extend({
      columns: 1,					// int - total number of columns
      resizeDelay: 100, 			// ms - the throttle delay for calling resize
      lang: 'en',
      breakpoints: {
        md: {
          columns: 2,
        },
        lg: {
          columns: 3,
        }
      },
      onmoduleloaded: null,		// fn(canvas, module, cfg, idx) loaded callback for module instances
      onmodulelayout: null, // fn(canvas, module, idx)
      onloaded: null,				// fn(canvas, layout) loaded callback for canvas
      onresize: null, 			// fn(canvas) resized callback
      onlayout: null,				// fn(canvas) layout callback
    }, opt);

    // el is top level item
    this.$el = $(opt.el);
    delete this.options.el;

    // Some other vars needed
    this._modules = [];

    // Initialize stuff
    this.initialize();
  };

  $.extend(ModuleCanvas.prototype, {
    initialize: function () {
      this.resize();

      var self = this;
      var resizeThrottle;
      $(window).resize(function () {
        if (resizeThrottle) {
          window.clearTimeout(resizeThrottle);
        }
        resizeThrottle = window.setTimeout(function () {
          resizeThrottle = null;
          self.resize();
        }, self._responsive.resizeDelay);
      });

      $(window).on('breakpoint', this.resize.bind(this));
    },

    load: function (layout) {
      this.activeLayout = layout;

      // Clear our current layout if any
      this.$el.empty();
      this._modules.length = 0;

      // Add the modules
      var self = this;
      var mod;

      $.each(layout.modules, function (idx, cfg) {
        if (!cfg) return;

        var type = cfg.type;
        if (!ModuleRegistry.isRegistered(type)) {
          type = 'blank';
        }

        var mod = ModuleRegistry.instance(type, self, cfg, idx);
        self._modules.push(mod);

        __callback(self, self._responsive, 'onmoduleloaded', self, mod, cfg, idx);
      });

      __callback(this, this._responsive, 'onloaded', this, layout);
      this.layout();
    },

    createRow: function (className) {
      return $('<div class="' + className + '"></div>');
    },

    layout: function () {
      var self = this;
      var bk = this.getBreakpoint();
      var maxWidth = this._responsive.columns;
      var rowWidth = 0;
      var size; var $row; var newLayout = [];

      $.each(this._modules, function (idx, m) {
        size = m.calculateUnitSize(bk);

        if ('full' === size.width) {
          // This has to be on a row of its own
          $row = self.createRow('module-row module-row-full');
          $row.append(m.$el);
          newLayout.push($row);

          // Don't create a new row yet, just clear the one we made
          // so a new one is made on the next module if present
          $row = null;
        } else {
          // We don't have a full width

          // Create a row if need be
          if (!$row || rowWidth + size.width > maxWidth) {
            $row = self.createRow('module-row');
            rowWidth = 0;
            newLayout.push($row);
          }

          // Append the module to the row
          $row.append(m.$el);

          // Check if row is full
          rowWidth += size.width;
          if (rowWidth >= maxWidth) {
            $row = null;
          }
        }

        m.resize(bk, size.width, size.height);
      });

      this.$el.empty().append(newLayout);
      $.each(this._modules, function (idx, m) {
        m.layout();
        __callback(self, self._responsive, 'onmodulelayout', self, m, idx);
      });

      bat.util.loader.hideLoader();
      __callback(this, this._responsive, 'onlayout', this);
    },

    resize: function () {
      // Update our options based on our breakpoints
      var bk = this.getBreakpoint();
      if (bk === this.activeBk) return;
      this.activeBk = bk;
      this._responsive = $.extend({}, this.options, this.options.breakpoints[bk]);

      // Trigger the callback handler if we have one
      __callback(this, this._responsive, 'onresize', this);

      // Update our layout with the new info
      this.layout();
    },

    getBreakpoint: function () {
      return responsive();
    },

    getLang: function () { return this.activeLayout.lang || this.options.lang; },
  });

  // Static functions
  ModuleCanvas.setResourceLocator = function (urlOrFn) {
    if (typeof urlOrFn === 'function') {
      __resourceLocator = urlOrFn;
    } else {
      __resourceLocator = function (url) { return urlOrFn + url; };
    }
  };

  // Some global items
  ModuleCanvas.sampleLayout = layout;

  return ModuleCanvas;
});

